export default {
  methods: {
    resetAllErrorCounters() {
      if (this.$refs.tabs) {
        for (let comp of this.$refs.tabs) {
          if (comp.resetErrorCounter) {
            comp.resetErrorCounter();
          }
        }
      }
    }
  }
};
